module.exports = __webpack_public_path__ + "img/pain-spot-7.32c74e50.svg";